import { render, staticRenderFns } from "./ResendApproval.vue?vue&type=template&id=92df5bcc&scoped=true&"
import script from "./ResendApproval.vue?vue&type=script&lang=js&"
export * from "./ResendApproval.vue?vue&type=script&lang=js&"
import style0 from "./ResendApproval.vue?vue&type=style&index=0&id=92df5bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92df5bcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92df5bcc')) {
      api.createRecord('92df5bcc', component.options)
    } else {
      api.reload('92df5bcc', component.options)
    }
    module.hot.accept("./ResendApproval.vue?vue&type=template&id=92df5bcc&scoped=true&", function () {
      api.rerender('92df5bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/modals/ResendApproval.vue"
export default component.exports